import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from "../lib/apiClient";

export default function Home() {
  const navigate = useNavigate();

  // load the family office. If it is locked, redirect to the welcome page.
  // otherwise, redirect to the first data view.
  useEffect(() => {
    async function fetchFamilyOfficeAndDataViews() {
      const { data: familyOffice } = await apiClient.get("/api/family_office");
      if (familyOffice && familyOffice.status?.is_locked) {
        navigate("/welcome/get_started");
      }
      else {
        const { data: dataViews } = await apiClient.get("/api/data_views");
        if (dataViews.length > 0) {
          navigate(`/views/${dataViews[0].id}`);
        }
      }
    }

    if (navigate) fetchFamilyOfficeAndDataViews();
  }, [navigate]);

  return "";
}

